
import { Component, Vue, Prop, namespace } from 'nuxt-property-decorator';
import { SessionTagDto, SessionTagAssignmentDto } from '../../services';
import Tag from '../Tag.vue';

const EventsModule = namespace('events');

@Component({
  components: {
    Tag,
  },
})
export default class SessionTagList extends Vue {
  @EventsModule.State sessionTags!: SessionTagDto[];
  @Prop({ required: true }) sessionTagAssignments!: SessionTagAssignmentDto[];

  get filteredSessionTags(): SessionTagDto[] {
    return this.sessionTags.filter(sessionTag =>
      this.sessionTagAssignments.some(({ sessionTagId }) => sessionTagId === sessionTag.id),
    );
  }
}
